var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "show-close": true,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "table-box" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.config.data, height: 420 } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "renew.title",
                  label: _vm.$t("customer.renewaltype"),
                  "min-width": "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "date",
                  label: _vm.$t("customer.renewaldate"),
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.end_date.slice(0, 4) !== "0000"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(scope.row.end_date)
                                    .format("YYYY-MM-DD")
                                )
                              ),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "date", label: "续费状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.renew_status == 1
                          ? _c("span", { staticClass: "color-warning" }, [
                              _vm._v("急需续费 "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.renew_status == 2
                          ? _c("span", { staticClass: "color-danger" }, [
                              _vm._v("已过期 "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.renew_status == 0
                          ? _c("span", { staticClass: "color-success" }, [
                              _vm._v("正常"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }